/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

// deep clone state
export function cloneState(state) {
    return JSON.parse(JSON.stringify(state));
}
